/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Last_Used_ColInputs */

const en_settings_apikeys_last_used_col = /** @type {(inputs: Settings_Apikeys_Last_Used_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Used`)
};

const zh_settings_apikeys_last_used_col = /** @type {(inputs: Settings_Apikeys_Last_Used_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近使用`)
};

/**
* | output |
* | --- |
* | "Last Used" |
*
* @param {Settings_Apikeys_Last_Used_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_last_used_col = /** @type {((inputs?: Settings_Apikeys_Last_Used_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Last_Used_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_last_used_col(inputs)
	return zh_settings_apikeys_last_used_col(inputs)
});
export { settings_apikeys_last_used_col as "settings.apikeys.last_used_col" }